import * as DashbaordTypes from "../types/dashboard.types";
import * as UiTypes from "../types/ui.types";
import axiosInstance from "../../api";
import { alertActions } from "./alert.actions";
import { ThunkDispatchType } from "../store";

export const loadDashboard = () => (dispatch: ThunkDispatchType) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: DashbaordTypes.LOADING_DAHSBOARD });

  axiosInstance
    .get("/dashboard/")
    .then((res) => {
      dispatch({
        type: DashbaordTypes.LOAD_DASHBOARD,
        payload: res.data.data,
      });
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      if (err.message) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.message,
        });
        dispatch(alertActions.error(err.message));
      } else if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};
